import { CRMAPIBase } from '@api/crmApiBase';
import { OrderReasonResp } from '@api/responseModels/orderReasons/orderReasonResponse';
import { OrderReasonsResp } from '@api/responseModels/orderReasons/orderReasonsResponse';
import { RequestResult } from '@api/responseModels/requestResult';

class OrderReasonsGroup extends CRMAPIBase {
    async getOrderReasons(crm_id: number, order_id): Promise<RequestResult<OrderReasonsResp>> {
        const result = await this.get<OrderReasonsResp>(`order-reasons`, {
            crm_id,
            order_id,
        });
        return result;
    }

    async getOrderReason(crm_id: number, id): Promise<RequestResult<OrderReasonResp>> {
        const result = await this.get<OrderReasonResp>(`order-reasons/${id}`, {
            crm_id,
        });
        return result;
    }

    async updateOrderReason({
        id,
        crm_id,
        order_id,
        title,
        description,
    }: {
        id: number;
        crm_id: number;
        order_id: number;
        title: string;
        description: string;
    }): Promise<RequestResult<OrderReasonResp>> {
        const result = await this.put<OrderReasonResp>(`order-reasons/${id}`, {
            crm_id,
            order_id,
            title,
            description,
        });
        return result;
    }

    async createOrderReason({
        crm_id,
        order_id,
        title,
        description,
    }: {
        crm_id: number;
        order_id: number;
        title: string;
        description: string;
    }): Promise<RequestResult<OrderReasonResp>> {
        const result = await this.post<OrderReasonResp>(`order-reasons`, {
            crm_id,
            order_id,
            title,
            description,
        });
        return result;
    }

    async deleteOrderReason(crm_id: number, id): Promise<RequestResult<OrderReasonResp>> {
        const result = await this.delete<OrderReasonResp>(`order-reasons/${id}`, {
            crm_id,
        });
        return result;
    }
}

export { OrderReasonsGroup };
